import classnames from 'classnames'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTE_ITINERARY_COMPUTING } from '../../routes'
import { navigateBack, navigateTo } from '../../store/history/history.actions'
import { resetItineraryExceptSteps } from '../../store/itinerary/itinerarySlice'
import SlideInOut from '../animation/SlideInOut'
import arrowLeft from '../genericComponents/assets/arrow-left.svg'
import RectangleActionButton, { COLOR_GREEN, SIZE_BIG } from '../genericComponents/buttons/RectangleActionButton'
import T from '../i18n/T'
import SVGIcon from '../svg/SVGIcon'
import { useAction } from '../utils/react-redux'
import s from './OptionsDialog.less'
import { areStepsFilled } from './steps/steps.selectors'

const Header = ({ title, onClick }) => {
  return (
    <div className={s.header}>
      <div className={classnames('icon', s.BackButton)} onClick={onClick}>
        <SVGIcon url={arrowLeft} />
      </div>
      <h2>
        <T id={title} />
      </h2>
    </div>
  )
}

export const BasicOptionsDialog = ({ title, children }) => {
  const dispatch = useDispatch()
  const execNavigateTo = useAction(navigateTo)
  const execNavigateBack = useAction(navigateBack)
  const shouldNavigateToItineraryComputing = useSelector(areStepsFilled)

  const exitHandler = () => {
    dispatch(resetItineraryExceptSteps())
    if (shouldNavigateToItineraryComputing)
      execNavigateTo({
        route: ROUTE_ITINERARY_COMPUTING
      })
    else execNavigateBack()
  }

  return (
    <dialog className={s.OptionsDialog}>
      <Header title={title} onClick={exitHandler} />
      <div className={s.content}>
        {children}
        <div className={s.OptionsDialogValidateArea}>
          <RectangleActionButton
            color={COLOR_GREEN}
            size={SIZE_BIG}
            onClick={exitHandler}
            className={s.OptionsDialogValidateButton}
            label="itinerary.options.validate"
          />
        </div>
      </div>
    </dialog>
  )
}

export default function OptionsDialog(props) {
  const { isDisplayed } = props
  return (
    <SlideInOut display={isDisplayed}>
      {() =>
        isDisplayed && (
          <>
            <Helmet>
              <body className={classnames(isDisplayed && 'unscrollable')} />
            </Helmet>
            <BasicOptionsDialog {...props} />
          </>
        )
      }
    </SlideInOut>
  )
}
